import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import _styles from "./assets/stylesheets/embed.css?url";
import _fonts from "./assets/stylesheets/base/fonts.css?url";

// Resolve to absolute URLs so the embed works cross-origin
const styles = new URL(_styles, import.meta.url).href;
const fonts = new URL(_fonts, import.meta.url).href;
import { isSupported, isPolyfilled, apply } from "invokers-polyfill/fn";

import App from "./app";
import { MemoryRouter } from "react-router";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      /* eslint-disable-next-line no-undef */
      filterKeys: [__SENTRY_APPLICATION_KEY__],
      behaviour: "drop-error-if-exclusively-contains-third-party-frames",
    }),
  ],
});

if (!isSupported() && !isPolyfilled()) apply();

class G1000PreferendumElement extends HTMLElement {
  // Static methods
  static tagName = "g1000-preferendum";

  static register(tagName = this.tagName, registry) {
    if ("customElements" in window) {
      (registry || customElements).define(tagName, this);
    }
  }

  #fontLink = null;

  // Instance methods
  connectedCallback() {
    this.#loadFonts();
    this.shadow = this.attachShadow({ mode: "closed" });
    this.renderElement();
  }

  disconnectedCallback() {
    this.#fontLink?.remove();
  }

  renderElement() {
    ReactDOM.createRoot(this.shadow).render(
      <MemoryRouter>
        <link rel="stylesheet" href={this.stylesheetURL} />
        {/* We hide the element itself, until our CSS is loaded */}
        <style>{":where(:host) { visibility: hidden; }"}</style>
        <App locale={this.locale} root={this} />
      </MemoryRouter>,
    );
  }

  get locale() {
    return this.lang || document.documentElement.lang;
  }

  get stylesheetURL() {
    return styles;
  }

  #loadFonts() {
    this.#fontLink = document.createElement("link");
    this.#fontLink.rel = "stylesheet";
    this.#fontLink.href = fonts;
    this.before(this.#fontLink);
  }
}

G1000PreferendumElement.register();
